import { cn } from "@/lib/utils";

import { DETAIL_GUTTER } from "./detail-parts";

// 열람 제한 화면 본문 (Figma ver.7 03-09-2): 공개 범위 기밀 + 열람 승인 없는 PwC 내부 회원.
// 헤더 · 분류 띠 · 바로가기는 일반 상세와 같고, 개요 아래는 흐린 자리 표시(본문 데이터는 서버가 내려주지 않아요) 위에 열람 승인 안내 카드를 놓아요.
// 열람 신청하기 · 처리 안내 문구는 2차라 1차에는 만들지 않아요(신청 버튼 숨김).

function Bar({ className }: { className?: string }) {
  return <div className={cn("rounded-[6px] bg-[#C9CCD1]", className)} />;
}

function GhostHeading({ children }: { children: string }) {
  return <h2 className="text-[40px] font-normal leading-[48px] text-nv-text-primary">{children}</h2>;
}

function Ghost() {
  return (
    <div aria-hidden className={cn(DETAIL_GUTTER, "pointer-events-none h-[946px] select-none overflow-hidden pt-[100px] blur-[7px]")}>
      <GhostHeading>개요</GhostHeading>
      <div className="mt-10 grid gap-10 lg:grid-cols-[minmax(0,1fr)_340px]">
        <div className="flex flex-col gap-[14px]">
          <Bar className="h-[14px] w-[70px]" />
          <Bar className="h-[34px] w-[88%]" />
          <Bar className="h-[16px] w-full" />
          <Bar className="h-[16px] w-full" />
          <Bar className="h-[16px] w-[60%]" />
        </div>
        <div className="h-[198px] rounded-[16px] bg-nv-bg-page" />
      </div>
      <div className="mt-[100px]">
        <GhostHeading>차별화 포인트</GhostHeading>
        <div className="mt-8 grid gap-4 md:grid-cols-2 xl:grid-cols-4">
          {[0, 1, 2, 3].map((i) => (
            <div key={i} className="flex h-[268px] flex-col gap-3 rounded-[16px] border border-nv-border bg-white p-7">
              <Bar className="h-9 w-10 bg-[#FFC8A8]" />
              <Bar className="h-[20px] w-[80%]" />
              <Bar className="h-[14px] w-full" />
              <Bar className="h-[14px] w-full" />
              <Bar className="h-[14px] w-[70%]" />
            </div>
          ))}
        </div>
      </div>
      <div className="mt-[100px]">
        <GhostHeading>핵심 AI 기술</GhostHeading>
        <div className="mt-10 border-t border-nv-border">
          {[0, 1].map((i) => (
            <div key={i} className="flex h-[108px] gap-8 border-b border-nv-border pt-[25px]">
              <Bar className="h-5 w-6 bg-[#FFC8A8]" />
              <Bar className="h-6 w-[160px]" />
              <Bar className="ml-24 h-5 w-[420px]" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export function RestrictedBody() {
  return (
    <div className="relative pb-[100px]">
      <Ghost />
      <div className="absolute left-1/2 top-[116px] w-[calc(100%-40px)] max-w-[570px] -translate-x-1/2">
        <div role="status" className="flex flex-col items-center rounded-[20px] border border-nv-border bg-white px-[45px] py-[41px] text-center shadow-[0_12px_40px_rgb(0_0_0_/_0.08)]">
          <h2 className="text-[24px] font-medium leading-[34px] text-nv-text-primary">열람 승인이 필요한 Asset입니다</h2>
          <p className="mt-4 max-w-[480px] break-keep text-[15px] leading-[25px] text-nv-text-secondary">
            기밀 등급 Asset은 열람 승인을 받은 사용자만 상세 정보를 볼 수 있습니다. 열람을 신청하면 Engagement Partner 승인 후 전체 내용이 공개됩니다.
          </p>
        </div>
      </div>
    </div>
  );
}
